import {
  AuthorizationAPIClient,
} from 'frontcore/domain/authorization/model/AuthorizationService.d'
import {
  PermissionCredentialsService,
  PermissionExtraParameters,
} from 'frontcore/domain/authorization/model/PermissionService.d'
import {
  ProfileRequestService,
  UserProfile,
} from 'frontcore/domain/profile/model/Profile.d'

export default class PermissionCredentialsServiceImpl implements PermissionCredentialsService {

  readonly #authorizationAPIClient: AuthorizationAPIClient
  readonly #profileService: ProfileRequestService

  constructor (
    authorizationAPIClient: AuthorizationAPIClient,
    profileService: ProfileRequestService
  ) {
    this.#authorizationAPIClient = authorizationAPIClient
    this.#profileService = profileService
  }

  async login (username: string, password: string, extraParameters: PermissionExtraParameters): Promise<{ extraParameters: PermissionExtraParameters, profile: UserProfile }> {
    const payload = { username, password, ...extraParameters}
    const token = await this.#authorizationAPIClient.login(payload)
    const profile = await this.#profileService.retrieve(token)
    return { extraParameters, profile }
  }

}
